/* import __COLOCATED_TEMPLATE__ from './client-section.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class ContactInformationClientSection extends Component {
  @action
  setIsMinor(isMinor) {
    let clientModel = this.args.clientModel;
    if (!clientModel) return;

    clientModel.set('isMinor', isMinor);
    clientModel.get('emails.firstObject')?.set('skipValidation', isMinor);
    this.args.onInputChange?.();
  }
}
